"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionHighchartsSettingsFilterCohortDaysComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
const antd_1 = require("antd");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const icons_1 = require("@ant-design/icons");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const use_custom_compare_1 = require("use-custom-compare");
const dropdownItemRender = (text, key, selectedValues, enabled) => {
    const iconShow = lodash_1.default.includes(selectedValues, key) ? "visible" : "hidden";
    return {
        key: key,
        disabled: !enabled,
        label: React.createElement(antd_1.Row, null,
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemLabel" }, text),
            React.createElement(antd_1.Col, { className: "multiSelectDropdownItemSelectedIcon", flex: "auto", style: { visibility: iconShow } },
                React.createElement(icons_1.CheckOutlined, null)))
    };
};
const RetentionHighchartsSettingsFilterCohortDaysComponent = () => {
    var _a, _b, _c;
    const retentionPageDataContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const { inProgress, loaded } = retentionPageDataContext.state.status;
    const { isError } = retentionPageDataContext.state.error;
    const chartHasNoData = ((_a = highchartsOptionsContext.state.chartStatus) === null || _a === void 0 ? void 0 : _a.status) === "noData";
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(retentionPageDataContext.state.data) || chartHasNoData;
    const filterCohortDays = retentionPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel().getFilterCohortDays();
    const filterCohortDaysIntervalStartTimeSec = ((_c = (_b = retentionPageDataContext.state.data) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.intervalStartTimeSec) || DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay().valueOf() / 1000;
    const [popupVisible, setPopupVisible] = (0, react_1.useState)(false);
    const filterCohortDaysOnChange = (0, use_custom_compare_1.useCustomCompareCallback)((clickedMenuKey) => {
        const chartSettingsJSONModel = retentionPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
        const filterCohortDays = chartSettingsJSONModel.getFilterCohortDays();
        const isAvgClicked = lodash_1.default.isEqual(RetentionChartSettingsJSONModel_1.HighchartsSettingsFilterCohortDays.avg, clickedMenuKey);
        if (isAvgClicked) {
            filterCohortDays.avg = !filterCohortDays.avg;
        }
        else {
            const clickedDayShift = lodash_1.default.toNumber(clickedMenuKey);
            if (lodash_1.default.includes(filterCohortDays.daysShift, clickedDayShift)) {
                lodash_1.default.remove(filterCohortDays.daysShift, e => e === clickedDayShift);
            }
            else {
                filterCohortDays.daysShift.push(clickedDayShift);
            }
        }
        if (!filterCohortDays.avg && lodash_1.default.isEmpty(filterCohortDays.daysShift)) {
            //reset AVG
            filterCohortDays.avg = true;
        }
        chartSettingsJSONModel.setFilterCohortDays(filterCohortDays);
        retentionPageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
    }, [retentionPageDataContext.stateFns], lodash_1.default.isEqual);
    const onClickMenu = (0, react_1.useCallback)(({ key }) => {
        filterCohortDaysOnChange(key);
    }, [filterCohortDaysOnChange]);
    const dropdownRender = (0, react_1.useCallback)((intervalStartTimeSec, filterCohortDays) => {
        // console.log("highchartsOptionsContext.state.options.series", highchartsOptionsContext.state.options.series);
        const seriesDataDayShifts = lodash_1.default.mapKeys(lodash_1.default.filter(lodash_1.default.map(highchartsOptionsContext.state.options.series, series => {
            var _a, _b;
            if (!((_a = series.custom) === null || _a === void 0 ? void 0 : _a.isAvg)) {
                return (_b = series.custom) === null || _b === void 0 ? void 0 : _b.dayShift;
            }
        }), lodash_1.default.isNumber));
        //selected values are sorted and then filtered to contain only items with data points
        let selectedDays = lodash_1.default.sortBy(filterCohortDays.daysShift);
        // selectedDays = _.filter(selectedDays, value => !_.isNil(seriesDataDayShifts[value]))
        let selectedValues = [];
        if (filterCohortDays.avg) {
            selectedValues.push(RetentionChartSettingsJSONModel_1.HighchartsSettingsFilterCohortDays.avg);
        }
        selectedValues = lodash_1.default.concat(selectedValues, selectedDays);
        // console.log("selectedValues", selectedValues);
        const initialMoment = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(intervalStartTimeSec * 1000).startOf("day");
        const momentRange = DateTimeFacade_1.DateTimeFacade.getMomentRange(initialMoment, DateTimeFacade_1.DateTimeFacade.getMomentFromCurrentDay());
        const numberOfDays = momentRange.diff("day");
        const arrayOfDatesWithFormat = DateTimeFacade_1.DateTimeFacade.getArrayOfDatesWithFormat(momentRange, DateTimeFacade_1.DateTimeFormatByFunctionality.HumanReadable.Common.DateOnly);
        const arrayOfDiffsByUnit = DateTimeFacade_1.DateTimeFacade.getArrayOfDiffsByUnit(momentRange, "day");
        const selectedValuesStrings = lodash_1.default.map(selectedValues, lodash_1.default.toString);
        const items = [
            dropdownItemRender(React.createElement(React.Fragment, null, "AVG"), RetentionChartSettingsJSONModel_1.HighchartsSettingsFilterCohortDays.avg, selectedValues, true),
            ...arrayOfDiffsByUnit.map((value, i) => {
                const dayShiftFromInitialDate = numberOfDays - value;
                /**
                 * here we try to find if there is a chart series with corresponding day shift index
                 * this logic will disable menu items which would display no data on highcharts
                 */
                const found = !lodash_1.default.isNil(seriesDataDayShifts[dayShiftFromInitialDate]);
                return dropdownItemRender(React.createElement(React.Fragment, null, arrayOfDatesWithFormat[i]), dayShiftFromInitialDate, selectedValues, found);
            })
        ];
        return React.createElement(antd_1.Menu, { multiple: true, className: "multiSelectDropdown multiSelectDropdownComponent", selectedKeys: selectedValuesStrings, onClick: onClickMenu, items: items });
    }, [onClickMenu, highchartsOptionsContext]);
    const onPopupVisibleChange = (popupVisible) => setPopupVisible(popupVisible);
    const overlay = dropdownRender(filterCohortDaysIntervalStartTimeSec, filterCohortDays);
    const isActive = !(0, RetentionChartSettingsJSONModel_1.isDefaultFilterCohortDays)(filterCohortDays);
    return React.createElement(React.Fragment, null,
        React.createElement(antd_1.Dropdown, { overlay: overlay, disabled: disabled, placement: "bottomRight", trigger: ["click"], className: `appMultiSelectComponent${popupVisible ? " appMultiSelectComponentActive" : ""}`, visible: popupVisible, onVisibleChange: onPopupVisibleChange },
            React.createElement(antd_1.Button, { icon: React.createElement(icons_1.FilterOutlined, null), disabled: disabled, type: isActive ? "primary" : "default" })));
};
exports.RetentionHighchartsSettingsFilterCohortDaysComponent = RetentionHighchartsSettingsFilterCohortDaysComponent;
